var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { minWidthMedia } from "@irati/ui/src/global/media";
export var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  ", "\n"], ["\n  margin-bottom: 10px;\n  ",
    "\n"])), minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 80%;\n  "], ["\n    max-width: 80%;\n  "]))));
export var Image = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 35px;\n"], ["\n  height: 35px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
